<template>
  <div class="rank-policy">
    {{ $t('proficiency.standard_update', { month: proficiencyUpdateDate.month, day: proficiencyUpdateDate.day }) }}
  </div>
</template>

<script>
  import moment from 'moment/src/moment';

  export default {
    name: 'cat-rank-policy',

    computed: {
      proficiencyUpdateDate() {
        const updateDate = moment();
        return {
          month: updateDate.month() + 1,
          day: updateDate.date(),
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .rank-policy {
    padding :12px 0px 0px 0px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
  }
</style>


// WEBPACK FOOTER //
// CatRankPolicy.vue?29f1a446